var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './index.scss';
import classnames from 'classnames';
import React from 'react';
const TextInput = (props) => {
    const { className, children, large, small, success, error } = props, rest = __rest(props, ["className", "children", "large", "small", "success", "error"]);
    const textInputClass = classnames('form-text-input', className, {
        large: large,
        small: small,
        success: success,
        error: error,
    });
    return (React.createElement("input", Object.assign({ type: "text", className: textInputClass }, rest), children));
};
export default TextInput;
